import React from 'react';

import { InputAction, StarIcon, StarBorderIcon } from '@gogame/components';

import { useFiltersSettings } from '../FiltersSettings';

const Favorite = ({ name, fontSize }) => {
  const { isFilterFavorite, onToggleFavorite } = useFiltersSettings();

  const filterFavorite = isFilterFavorite({ name });

  const handleToggleFavorite = () => onToggleFavorite({ name });

  const tooltip = filterFavorite
    ? 'Remove favorite filter'
    : 'Add favorite filter';

  return (
    <InputAction
      key={tooltip}
      icon={filterFavorite ? <StarIcon /> : <StarBorderIcon />}
      tooltip={tooltip}
      onClick={handleToggleFavorite}
      fontSize={fontSize}
    />
  );
};

export default Favorite;
